export interface ApiResponse<T = unknown> {
  statusCode: string;
  message: string;
  data?: T | PaginatedResponse<T>;
  errors?: Array<{
    code: number;
    path: string;
    message: string;
  }>;
  details?: {
    actions?: Array<'linkAccount' | 'verifyEmail' | 'login' | 'requires_payment_method'>;
    filenames?: string[];
    retryAfter?: number;
    rateLimitInfo?: {
      limit: number;
      remaining: number;
      reset: number;
    };
  };
}

export interface PaginatedResponse<T> {
  results: T[];
  total: number;
}

export const API_STATUS_CODES = {
  SUCCESS: '10000',
  FAILURE: '10001',
  RETRY: '10002',
  INVALID_ACCESS_TOKEN: '10003',
} as const;

export type ApiStatusCode = typeof API_STATUS_CODES[keyof typeof API_STATUS_CODES];

export type ApiErrorType = 
  | 'BadRequest'
  | 'Unauthorized'
  | 'PermissionDenied'
  | 'NotFound'
  | 'Conflict'
  | 'TooLarge'
  | 'Unprocessable'
  | 'RateLimited'
  | 'ServiceUnavailable'
  | 'DefaultResponse';

export type ApiErrorAction = 
  | 'verifyEmail'
  | 'linkAccount'
  | 'login'
  | 'requires_payment_method';

export interface RequestMetadata {
  locale?: string;
  timezone?: string;
  clientVersion?: string;
  deviceInfo?: string;
} 